export const enum BGColor {
    Yellow = 'yellow',
    Pink = 'pink',
    Red = 'red',
    Green = 'green',
    Mint = 'mint',
    Blue = 'blue',
    Orange = 'orange',
    Magenta = 'magenta',
    Purple = 'purple',
    Copper = 'copper',
    Ocean = 'ocean',
}

export enum UserColor {
    Yellow = '#EBB409',
    Red = '#FF5958',
    Orange = '#FFAC3C',
    Green = '#5ECF71',
    Blue = '#49A0F6',
    Purple = '#9F6FEE',
    Gray = '#969A9E',
}
